import React, { useEffect, useRef, useState } from 'react';

const testimonials = [
  { name: 'Khurshid Ahmed', role: 'Velvet Scent', video: '/assets/videos/testimonials/Review Video Velvetscent.mp4' },
  { name: 'Imtiyaz Bhai', role: 'White Label Partner', video: '/assets/videos/testimonials/Review Video Tina Bhai.mp4' },
  { name: 'Saddam Ansari', role: 'Full2SMS', video: '/assets/videos/testimonials/Review Video Saddam Ansari.mp4' },
  { name: 'Hafiz Muhammad Shakir', role: 'Islamic And Tech', video: '/assets/videos/testimonials/islamic-and-tech-review.mp4' },
];

const VideoTestimonials = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const previewRefs = useRef([]);
  const modalVideoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && activeIndex === null) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.45 });
    previewRefs.current.forEach((video) => video && observer.observe(video));
    return () => observer.disconnect();
  }, [activeIndex]);

  useEffect(() => {
    if (activeIndex === null) return undefined;
    document.body.classList.add('video-testimonial-modal-open');
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setActiveIndex(null);
      if (event.key === 'ArrowRight') setActiveIndex((index) => (index + 1) % testimonials.length);
      if (event.key === 'ArrowLeft') setActiveIndex((index) => (index - 1 + testimonials.length) % testimonials.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.classList.remove('video-testimonial-modal-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeIndex]);

  useEffect(() => {
    if (activeIndex !== null && modalVideoRef.current) {
      modalVideoRef.current.load();
      modalVideoRef.current.play().catch(() => {});
    }
  }, [activeIndex]);

  const showPrevious = () => setActiveIndex((index) => (index - 1 + testimonials.length) % testimonials.length);
  const showNext = () => setActiveIndex((index) => (index + 1) % testimonials.length);

  return (
    <section className="home-video-testimonials" aria-labelledby="video-testimonials-title">
      <div className="home-video-testimonials-pattern" aria-hidden="true"></div>
      <div className="auto-container">
        <div className="sec-title centered home-video-testimonials-heading">
          <div className="title">CLIENT VIDEO TESTIMONIALS</div>
          <h2 id="video-testimonials-title">Real Clients. Real Experiences.</h2>
          <div className="text">Hear directly from clients who worked with SwiftMaze Tech on their digital projects.</div>
        </div>

        <div className="home-video-testimonial-track">
          {testimonials.map((testimonial, index) => (
            <article className="home-video-testimonial-card" key={testimonial.name}>
              <button type="button" className="home-video-testimonial-preview" onClick={() => setActiveIndex(index)} aria-label={`Play video testimonial from ${testimonial.name}`}>
                <video ref={(node) => { previewRefs.current[index] = node; }} src={testimonial.video} muted loop playsInline preload="metadata" aria-hidden="true" />
                <span className="home-video-testimonial-shade" aria-hidden="true"></span>
                <span className="home-video-testimonial-play" aria-hidden="true"><i className="fa fa-play"></i></span>
                <span className="home-video-testimonial-watch" aria-hidden="true">Watch Review</span>
              </button>
              <div className="home-video-testimonial-copy"><h3>{testimonial.name}</h3><p>{testimonial.role}</p></div>
            </article>
          ))}
        </div>
      </div>

      {activeIndex !== null ? (
        <div className="video-testimonial-modal" role="dialog" aria-modal="true" aria-label={`${testimonials[activeIndex].name} video testimonial`} onMouseDown={(event) => { if (event.target === event.currentTarget) setActiveIndex(null); }}>
          <button type="button" className="video-testimonial-close" onClick={() => setActiveIndex(null)} aria-label="Close video testimonial"><span aria-hidden="true">&times;</span></button>
          <button type="button" className="video-testimonial-nav video-testimonial-nav--previous" onClick={showPrevious} aria-label="Previous testimonial"><i className="fa fa-angle-left" aria-hidden="true"></i></button>
          <div className="video-testimonial-player">
            <video ref={modalVideoRef} src={testimonials[activeIndex].video} controls playsInline preload="metadata" />
            <div className="video-testimonial-player-meta"><strong>{testimonials[activeIndex].name}</strong><span>{testimonials[activeIndex].role}</span></div>
          </div>
          <button type="button" className="video-testimonial-nav video-testimonial-nav--next" onClick={showNext} aria-label="Next testimonial"><i className="fa fa-angle-right" aria-hidden="true"></i></button>
        </div>
      ) : null}
    </section>
  );
};

export default VideoTestimonials;
